import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import DropDown from '@/common/dropdown.vue';
import { readCookie } from '@/tools/tools';
import { pageVisit as _pageVisit, saveFeedBack, uploadFile } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.content = '';
    _this.isRemark = false;
    _this.mobileNo = '';
    _this.feedbackType = 1;
    _this.fileList = [];
    _this.currentIndex = 0;
    // 上传图片id
    _this.imageIds = '';
    _this.feedbackList = [{
      name: '功能异常',
      id: 1
    }, {
      name: '体验问题',
      id: 2
    }, {
      name: '产品建议',
      id: 3
    }, {
      name: '其他问题',
      id: 4
    }];
    _this.maxpic = false; // 是否上传到最大数量
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {}
  }, {
    key: "handleChange",
    value: function handleChange() {
      this.isRemark = this.content === '';
    }
    // 选择问题类型
  }, {
    key: "selectFeedBack",
    value: function selectFeedBack(id, index) {
      this.currentIndex = index;
      this.feedbackType = id;
      this.$refs.upload.value = '';
    }
    // 上传图片
  }, {
    key: "uploadpic",
    value: function () {
      var _uploadpic = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var file, uploadlength, form, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              file = _toConsumableArray(event.target.files);
              if (!(this.fileList.length < 3)) {
                _context.next = 9;
                break;
              }
              uploadlength = 3 - this.fileList.length;
              form = new FormData();
              file.forEach(function (value) {
                form.append('fileData', value);
                form.append('type', '11');
              });
              _context.next = 7;
              return uploadFile(form);
            case 7:
              res = _context.sent;
              if (res.data.code === 100) {
                this.fileList = [].concat(_toConsumableArray(this.fileList), _toConsumableArray(res.data.data.slice(0, uploadlength)));
                this.maxpic = this.fileList.length === 3;
                this.imageIds = this.fileList.map(function (e) {
                  return e.id;
                }).join(',');
              } else {
                this.$message.error(res.data.message);
              }
            case 9:
              this.$refs.upload.value = '';
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function uploadpic(_x) {
        return _uploadpic.apply(this, arguments);
      }
      return uploadpic;
    }() // 删除上传图片
  }, {
    key: "removefile",
    value: function removefile(index) {
      this.fileList.splice(index, 1);
      this.maxpic = false;
    }
    // 添加反馈意见
  }, {
    key: "saveFeedback",
    value: function () {
      var _saveFeedback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.content === '')) {
                _context2.next = 4;
                break;
              }
              this.isRemark = true;
              _context2.next = 8;
              break;
            case 4:
              _context2.next = 6;
              return saveFeedBack({
                id: '',
                platform: 2,
                content: this.content,
                imageIds: this.imageIds,
                feedbackType: this.feedbackType,
                mobileNo: this.mobileNo,
                companyId: 1
              });
            case 6:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.content = '';
                this.currentIndex = 0;
                this.imageIds = '';
                this.fileList = [];
                this.mobileNo = '';
                this.feedbackType = 1;
                this.maxpic = false;
                this.$message.success({
                  showClose: true,
                  dangerouslyUseHTMLString: true,
                  message: "\n            <p style=\"margin-bottom: 8px; color: #333; font-size: 14px;\">\u63D0\u4EA4\u6210\u529F</p>\n            <span style=\"display: block; color: #999; font-size: 12px;\">\u611F\u8C22\u60A8\u7ED9\u6211\u4EEC\u63D0\u51FA\u7684\u5B9D\u8D35\u610F\u89C1\uFF0C\u5E2E\u52A9\u6211\u4EEC\u5B8C\u5584\u4EA7\u54C1\uFF0C\u8C22\u8C22\uFF01</span>\n          "
                });
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveFeedback() {
        return _saveFeedback.apply(this, arguments);
      }
      return saveFeedback;
    }() // 访问页面数据埋点
  }, {
    key: "pageVisit",
    value: function pageVisit() {
      var anchor = readCookie('anchor');
      _pageVisit({
        pageType: 14,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    DropDown: DropDown,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;